import Background from "../components/Background";
import NavTopBar from "../components/NavTopBar";
import { withRouter } from "react-router-dom";
import PlainContainer from "../components/PlainContainer";
import { useLocation, useParams } from "react-router";
import { useEffect, useState } from "react";
import Button from "../components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import OrderItemsTable from "../components/OrderItemsTable";
import OrderInformation from "../components/OrderInformation";
import Footer from "../components/Footer";
import { enqueueSnackbar } from "notistack";
import { exportToMARC21 } from "../utils/marc21";

const OrderDetailsView = ({ history }) => {

  const { id } = useParams();
  const { state } = useLocation();
  const order = state?.order;

  const loggedUser = useSelector((state) => state.authentication.user);
  const [filename, setFilename] = useState('');

  const [isExporting, setIsExporting] = useState(false);




  const exportFiles = async () => {
    if (!order.items || order.items.length === 0) {
      enqueueSnackbar("Brak pozycji do eksportu", { variant: "warning" });
      return;
    }
    try {

      setIsExporting(true);
      exportToMARC21(order.items, order.id, filename, "Storybox.pl", "Biblioteka - przy T.Kościuszki 49");
      enqueueSnackbar(`Wyeksportowano ${order.items.length} rekordów MARC21 (.txt i .mrc)`, { variant: "success" });

    } catch (error) {
      console.error('Error exporting MARC21:', error);
      enqueueSnackbar("Błąd podczas eksportu MARC21", { variant: "error" });
    } finally {
      setIsExporting(false);
    }

  }

  useEffect(() => {
    const timestamp = new Date(order.orderDate).toISOString().split('T')[0]; // Format date as YYYY-MM-DD
    setFilename(`zamowienie_${order.id}_(${timestamp})`);
  }, [order]);

  return (
    <>
      <NavTopBar />
      <Background height="45vh" />
      <PlainContainer
        heightInVh={4.5}
        widthInVw={0}
        customStyles={{
          top: "12vh",
          width: "95vw",
          position: "absolute",
          left: "2.5vw",
          paddingBottom: "0px",
          backgroundColor: "transparent",
          display: "flex",
          justifyContent: "space-between",
          boxShadow: "none",
        }}
      >

        <Button
          text={
            <div style={{ display: "flex" }}>
              <FontAwesomeIcon
                icon={faChevronLeft}
                style={{
                  alignSelf: "center",
                  marginRight: "6px",
                }}
              />
              Powrót
            </div>
          }
          onClick={() => history.goBack()}
          styleOptions={{
            height: "100%",
          }}
        />
        <div style={{ display: 'flex', alignItems: 'end', gap: '10px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <label htmlFor="filename-input" style={{ fontSize: '12px', color: '#666', marginBottom: '2px' }}>
              Nazwa plików MARC21 (.mrc i .mrk):
            </label>
            <input
              id="filename-input"
              type="text"
              value={filename}
              onChange={(e) => setFilename(e.target.value)}
              placeholder="Nazwa plików bez rozszerzenia"
              style={{
                padding: '6px 8px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                fontSize: '14px',
                width: '250px',
                marginRight: '10px'
              }}
            />
          </div>
          <Button
            onClick={() => {
              return exportFiles()
            }}
            disabled={!order.items || order.items.length === 0 || isExporting}
            text={
              <div style={{ display: "flex", color: order.items && order.items.length > 0 ? "#f4f4f4" : '#6c757d' }}>
                {isExporting ? 'Eksportowanie...' : 'Eksport MARC21...'}
              </div>
            }>
          </Button>

        </div>
      </PlainContainer>

      <PlainContainer
        customStyles={{
          top: "18vh",
          width: "95vw",
          height: "20vh",
          position: "absolute",
          left: "2.5vw",
          paddingBottom: "0px",
        }}
      >
        <OrderInformation order={order} />
      </PlainContainer>

      <PlainContainer
        heightInVh={'auto'}
        widthInVw={95}
        customStyles={{
          top: "40vh",
          position: "absolute",
          left: "2.5vw",
          paddingBottom: "0px",
        }}
      >
        {/* Order Items Table */}
        {(
          <PlainContainer
            widthInVw={95}
            customStyles={{
              marginTop: "30px",
              padding: "10px",
              top: "-3vh",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              paddingBottom: "0px",
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <div style={{
                textAlign: "left",
                fontSize: "3vh",
                position: "relative",
                top: "2vh",
              }}>
              </div>
            </div>
            <OrderItemsTable items={order.items} />
          </PlainContainer>
        )}
      </PlainContainer>
      <Footer />
    </>
  );
};

export default withRouter(OrderDetailsView);
